export default __webpack_public_path__ + "static/media/video-thumbnail.aa085afb.png";